import { Typography } from "@mui/material";
import React from "react";
import styles from "./ApplicationsTable.module.css";
import { format } from "date-fns";
import { convertToLocaleString } from "utils/helpers";

const headData = [
  "Application ID",
  "Property Value",
  "Equity Contribution",

  "Date Applied",

  "Category",
  "Status",
];
function ApplicationsTable({ data }) {
  return (
    <div className={styles.applications_table}>
      <table>
        <thead>
          <tr>
            {headData.map((item) => {
              return <td key={item}>{item}</td>;
            })}
          </tr>
        </thead>
        <tbody>
          {data?.map((item) => {
            return (
              <tr
                onClick={() => {
                  //handleOpenApplicationsModal(item)
                }}
                key={item.id}
              >
                <td>
                  <div className={styles.app_id}>
                    {/* <input type="checkbox" name="" id="" />{" "} */}
                    <Typography> {item.applicationId} </Typography>
                  </div>
                </td>
                <td>₦ {convertToLocaleString(item.propertyPrice) || 0}</td>
                <td>
                  ₦{" "}
                  {convertToLocaleString(item.propertyEquityContribution) || 0}
                </td>
                <td>{format(new Date(item.createdAt), "dd/MM/yyyy")} </td>

                <td>{item.category || "NA"}</td>
                <td>
                  <div
                    className={`${styles.status} 
                    ${item.status === "completed" && styles.status_completed} 
                    ${item.status === "pending" && styles.status_pending} 
                    ${item.status === "approved" && styles.status_approved}
                    ${item.status === "rejected" && styles.status_failed}`}>
                    <Typography>{item.status}</Typography>
                  </div>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
}

export default ApplicationsTable;